// Must run before any module below pulls in the store, which hydrates
// persisted state on evaluation — the guard purges stale-build state first.
import '@/cacheGuard'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import '@/scss/app.scss'

createApp(App).use(store).use(router).mount('#app')
